import { render, staticRenderFns } from "./SchedaProgetto.vue?vue&type=template&id=e12cf398&"
import script from "./SchedaProgetto.vue?vue&type=script&lang=js&"
export * from "./SchedaProgetto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports